<template>
  <app-data-editor
    :id="id"
    title="Редактирование тарифа"
    resource="tariffs"
    :elements="elements"
    add-message="Тариф добавлен"
    edit-message="Тариф изменен"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Направление",
            name: "direction",
            control: {
              type: "reference",
              component: "Country",
              resource: "countries",
              required: true,
              rules: [v => !!v || "Направление обязательно к заполнению"],
            },
            default: "",
          },
          {
            title: "Категория товара",
            name: "productCategory",
            control: {
              type: "reference",
              component: "ProductCategory",
              resource: "product-categories",
              required: true,
              rules: [v => !!v || "Категория товара обязательно к заполнению"],
            },
            default: "",
          },
        ],
        [
          {
            title: "Описание категории товара",
            name: "productCategoryDescription",
            control: {
              type: "title-text",
            },
            default: "",
          },
          {
            title: "Тип",
            name: "goodsType",
            control: {
              type: "reference",
              component: "GoodsType",
              resource: "goods-types",
              required: true,
              rules: [v => !!v || "Тип обязательно к заполнению"],
            },
            default: "",
          },
        ],
        [
          {
            title: "Стандартный объемный вес",
            name: "standardVolumetricWeight",
            control: {
              type: "title-text",
            },
            default: "",
          },
          {
            title: "Тариф",
            name: "TariffValue",
            control: {
              type: "title-text",
            },
            default: "",
          },
          {
            title: "Валюта",
            name: "currency",
            control: {
              type: "reference",
              component: "Currency",
              resource: "currencies",
              required: true,
              rules: [v => !!v || "Валюта обязательно к заполнению"],
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>